import { useState } from 'react';
import { useDispatch } from 'react-redux';

//
import Text from '../../../molecules/Text';

//
import { setHeader } from '../../../../../../../Redux/slices/certificate';

/**
 *
 */
function SupTitle({ headerState, preview }) {
  const { supTitle } = headerState;
  const { text, color, fontSize, alignment } = supTitle;
  const dispatch = useDispatch();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = (supTitleValue) => {
    dispatch(
      setHeader({
        ...headerState,
        supTitle: supTitleValue
      })
    );
  };

  return (
    <Text
      show={show}
      text={text}
      color={color}
      preview={preview}
      title={'Sup Title'}
      initialValue={supTitle}
      fontSize={fontSize}
      alignment={alignment}
      //
      handleSave={handleSave}
      handleShow={handleShow}
      handleClose={handleClose}
    />
  );
}

export default SupTitle;
